export const API = {
    BASE_URL: process.env.REACT_APP_DEV ? process.env.REACT_APP_API_BASE_URL_DEV+"/api" : null,
    LOCAL_BASE_URL: "http://localhost:3001/",
    BASE_URL_ADMIN: process.env.REACT_APP_DEV ? process.env.REACT_APP_API_BASE_URL_DEV_ADMIN : null,
    HIT_DUMMY_URL: process.env.REACT_APP_HIT_DUMMY_API,
    CAINZ_BASE_URL: process.env.REACT_APP_API_CAINZ_BASE_URL,
    SSE_API_PATH: `${process.env.REACT_APP_API_BASE_URL_DEV}/sse/events/notification`,
};